// extracted by mini-css-extract-plugin
export default {"alertList":"AlertsContext_alertList__E8FYN","alertItem":"AlertsContext_alertItem__ljmh1"};